import styled from 'styled-components';
import { flexPosition, fontStyle } from '../../../../styles/mixins';
import {
  GRAY_LIGHTER,
  GRAY_DARKER,
  FONT_SIZE_7,
  FONT_WEIGHT_NORMAL,
  FONT_WEIGHT_BOLD,
  INFO_COLOR,
  FONT_SIZE_6,
} from '../../../../styles/variables';

export const ItemContainer = styled.div`
  width: 100%;
  ${flexPosition({ align: 'center', justify: 'space-between' })}
  padding: 0px 5px;
`;

export const LeftInfo = styled.div`
  ${flexPosition({ align: 'center', justify: 'flex-start' })}
`;

export const ImageContainer = styled.div`
  position: relative;
  width: 50px;
  height: 50px;
  ${flexPosition({ align: 'center', justify: 'center' })}
  border: 1px solid ${GRAY_LIGHTER};
  border-radius: 3px;
`;

export const Image = styled.img`
  max-width: 100%;
  max-height: 100%;
`;

export const ProductName = styled.p`
  ${fontStyle(GRAY_DARKER, FONT_SIZE_7, FONT_WEIGHT_NORMAL)}
  margin: 0;
  margin-left: 10px;
`;

export const LineSeparator = styled.div`
  width: 100%;
  border-bottom: 1px solid ${GRAY_LIGHTER};
  margin: 15px 0px;
  position: relative;
`;

export const LogicOperatorTip = styled.span`
  position: absolute;
  top: -10px;
  right: 20%;
  background-color: #fff;
  border: 1px solid ${GRAY_LIGHTER};
  border-radius: 100px;
  height: 23px;
  width: 23px;
  ${fontStyle(GRAY_DARKER, '9px', FONT_WEIGHT_BOLD)}
  ${flexPosition({ align: 'center', justify: 'center' })}
`;

export const VariationsContainer = styled.div`
  position: absolute;
  top: 100%;
  left: 80%;
  width: 200px;
`;

export const VariationsList = styled.ul`
  ${flexPosition({ align: 'flex-start', justify: 'flex-start' })}
  flex-direction: column;
  position: relative;
  padding: 0;
  list-style: none;
  &::before {
    content: '';
    position: absolute;
    border-left: 2px solid ${GRAY_LIGHTER};
    left: -15px;
    height: calc(100% - 10px);
  }
`;

export const Variation = styled.li`
  margin-bottom: 12px;
  position: relative;
  ${flexPosition({ align: 'center' })}
  ${fontStyle(INFO_COLOR, FONT_SIZE_6, FONT_WEIGHT_BOLD)}
  &:first-child {
    padding-top: 15px;
  }
  &:last-child {
    margin-bottom: 0;
  }

  &::before {
    content: '';
    position: absolute;
    left: -19px;
    height: 10px;
    width: 10px;
    border: 2px solid ${GRAY_LIGHTER};
    border-radius: 100px;
    background-color: #fff;
  }
`;



// WEBPACK FOOTER //
// ./src/components/ProductAddons/CustomSteps/ProductAddonItem/style.js